import { round } from 'lodash-es'

// Clone of ruby's divmod
const divmod = (score: number, divisor: number): number[] => {
  const quotient = Math.floor(score / divisor)
  const remainder = score % divisor

  return [quotient, remainder]
}

// Calculates a value that fills stars more accurately than raw score
const adjustDecimalScore = (decimalScore: number): number => {
  if (decimalScore > 0.165 && decimalScore <= 0.415) {
    return 0.4
  } else if (decimalScore > 0.415 && decimalScore <= 0.585) {
    return 0.5
  } else if (decimalScore > 0.585 && decimalScore <= 0.835) {
    return 0.6
  } else if (decimalScore > 0.835) {
    return 1.0
  } else {
    return 0.0
  }
}

// See rating_util.rb for the file of which this is meant to be a clone
export const RatingUtil: { round: Function, roundForStars: Function } = {
  round: (score: number): number => {
    return round(score, 1)
  },

  roundForStars: (score: number): number => {
    const [integerScore, decimalScore] = divmod(score, 1)
    const adjustedDecimalScore = adjustDecimalScore(decimalScore)

    return round(integerScore + adjustedDecimalScore, 1) * 10
  }
}
